<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-4">
    <form v-bind:id="'schedulingCreateForm' + getId()" name="schedulingCreateForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row mt-0" v-if="openInPopup=='false'">

        <div class="row mt-0" v-if="id <= 0">
          <div class="col custom-form-main-label">
            {{$t('add_scheduling')}}
          </div>
        </div>
        <div class="row mt-0" v-if="id > 0">
          <div class="col custom-form-main-label">
            {{$t('manage_scheduling')}}
          </div>
        </div>

      </div>
      <div class="row mt-3" v-if="openInPopup=='false'">
        <div class="col-lg-12  p-0 custom-form-label">
          {{$store.translate('procedure')}}
        </div>
      </div>
      <div class="row mt-1" v-if="openInPopup=='false'">
        <div class="col">
          <procedure-selector ref="procedureselector" @event-change-procedure="onChange"></procedure-selector>
        </div>
      </div>
      <div class="row mt-3" v-if="showTargetProcedure==true && openInPopup=='false'">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('target_procedure')}}
        </div>
      </div>
      <div class="row mt-1" v-if="showTargetProcedure==true && openInPopup=='false'">
        <div class="col">
          <procedure-selector ref="targetprocedureselector" @event-change-procedure="onTargetChange"></procedure-selector>
        </div>
      </div>
      <div class="row mt-3" v-show="isSuperAdmin=='True'">
        <div class="col p-0">
          <input-checkbox @input="setOverride" v-bind:id="'chk_global'"
                          v-bind:name="'chk_global'" v-bind:checked="isGlobal"
                          v-bind:text="checkboxlable" class="mt-1"></input-checkbox>
        </div>
      </div>


      <div class="row mt-3">
        <div class="col">
          <create-schedule ref="createScheduleControl" @changetype="changeType"></create-schedule>
        </div>
      </div>
      <div class="row mt-3" v-show="projectCount>0 && isGlobal==false">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('assigntoproject')}}
        </div>
      </div>
      <div class="row mt-1" v-show="projectCount>0 && isGlobal==false">
        <div class="col">
          <project-selector ref="projectselector" :loadDataOnInit="true" @eventdata="onProjectData" @event-change-project="onChangeProject"></project-selector>
        </div>
      </div>
      <div class="row mt-3" v-show="locationCount>0 && isGlobal==false">
        <div class="col-lg-12 p-0 custom-form-label">
          {{ $store.translate('assigntolocation')}}
        </div>
      </div>
      <div class="row mt-1" v-show="locationCount>0 && isGlobal==false">
        <div class="col">
          <location-selector @change="onChangeLocation" :loadDataOnInit="true" showSublocations="true" @eventdata="onLocationData" ref="locationselector"></location-selector>
        </div>
      </div>
      <div class="row mt-3" v-show="shiftCount>0 && isGlobal==false">
        <div class="col-lg-12  p-0 custom-form-label">
          {{ $store.translate('assigntoshift')}}
        </div>
      </div>
      <div class="row mt-1" v-show="shiftCount>0 && isGlobal==false">
        <div class="col px-0">
          <!--this-->
          <shift-select-selector ref="shiftselector" :loadDataOnInit="true" @eventdata="onShiftData" @event-change-shift="onChangeShift"></shift-select-selector>
        </div>
      </div>

      <div class="row mt-3" v-show="isGlobal==false && showAssignUser==true">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('assigntospecific')}}
        </div>
      </div>
      <div class="row mt-1" v-show="isGlobal==false && showAssignUser==true">
        <div class="col px-0">
          <select v-model="selectedtype" class="form-control schedulerselect" v-bind:id="'select_assigned_type_' +  getId()" v-on:change="onTypeChange" v-select>
            <option value="">{{$t('select')}}</option>
            <option value="user">{{$t('user')}}</option>
            <option value="team">{{$store.translate('team')}}</option>
            <option value="teammember">{{$store.translate('each_user_in_team')}}</option>
          </select>
        </div>
      </div>
      <div class="row mt-1" v-show="selectedtype === 'user' && isGlobal==false">
        <div class="col px-0">
          <user-selector ref="userSelectorRef" loadDataOnInit="false" @event-change-member="onChangeMember"></user-selector>
        </div>
      </div>
      <div class="row mt-3" v-show="isGlobal==false && selectedOption=='addedtoteam'">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('team')}}
        </div>
      </div>
      <div class="row mt-1" v-show="(selectedtype === 'team' ||  selectedtype === 'teammember' || selectedOption=='addedtoteam') && isGlobal==false">
        <div class="col px-0">
          <team-select-selector loadDataOnInit="false" style="width:100%" ref="teamSelectorRef" @event-change-team="onChangeTeam"></team-select-selector>
        </div>
      </div>

      <div class="row mt-3" v-if="showStatus=='true'">
        <div class="col px-0">
          {{$t('status')}}
        </div>
      </div>
      <div class="row mt-1" v-show="showStatus=='true'">
        <div class="col px-0">
          <select v-model="status" class="form-control schedulerselect" v-bind:id="'select_status_' +  getId()" v-select>
            <option value="0">{{$t('active')}}</option>
            <option value="1">{{$t('paused')}}</option>
          </select>
        </div>
      </div>
      <div class="row mt-3" v-if="showOrder=='true' && id>0">
        <div class="col px-0">
          {{$t('order')}}
        </div>
      </div>
      <div class="row mt-1" v-if="showOrder=='true' && id>0">
        <div class="col px-0">
          <input v-model="order" type="number" id="txtorder" v-bind:placeholder="$t('order')" maxlength="5" name="order" class="form-control" />
        </div>
      </div>
      <div class="row px-0 mt-1">
        <div class="text-right col-sm-12 mt-1 px-0 text-right">
          <button type="submit" class="btn skin primary-button mt-1" @click="createSchedule">{{$t('save')}}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import CreateSchedule from '../Scheduling/create-schedule.vue'
  import ProcedureSelector from '../procedure/procedure-selector.vue'
  import ProjectSelector from '../project/project-selector.vue'
  import LocationSelector from '../location/location-selector.vue'
  import ShiftSelector from '../shift/shift-select-selector.vue'
  import TeamSelector from '../team/team-select-selector'
  import MemberSelector from '../user/user-selector.vue'
  var procedureId = -1;
  var isGlobal = false;
  var checkboxlable = "Global";
  var isSuperAdmin = 'False';
  var selectedtype = '';
  var id = 0;
  var order = '';
  var status = 0;
  var showAssignUser = true;
  var selectedOption = '';
  export default {
    name: "add-schedule-selector",
    components: {
      CreateSchedule,
      ProcedureSelector,
      ProjectSelector,
      LocationSelector,
      ShiftSelector,
      TeamSelector,
      MemberSelector,
    },
    props: {
      teamId: {
        type: String,
        default: null
      },
      openInPopup: {
        required: false,
        type: String,
        default: "false"
      },
      showOrder: {
        required: false,
        type: String,
        default: "false"
      },
      showStatus: {
        required: false,
        type: String,
        default: "false"
      },
    },
    data() {
      return {
        selectedOption: '',
        showAssignUser: true,
        showTargetProcedure: false,
        targetProcedureId: -1,
        procedureId: -1,
        projectId: -1,
        locationId: -1,
        shiftId: -1,
        projectCount: 0,
        locationCount: 0,
        shiftCount: 0,
        isGlobal: false,
        checkboxlable: "Global",
        isSuperAdmin: 'False',
        selectedtype: '',
        memberId: '',
        teamId: -1,
        id: 0,
        order: '',
        status: 0,
      };
    },



    methods: {
      changeType(type) {
        //if (type == 'onproceduredone') {
        //  this.showTargetProcedure = true;
        //}
        //else {
        //  this.showTargetProcedure = false;
        //}
        this.showTargetProcedure = false;
        this.showAssignUser = true;
        this.selectedOption = type;
        switch (type) {
          case 'onproceduredone':
            this.showTargetProcedure = true;
            break;
          case 'addedtoteam':
            this.showAssignUser = false;
            break;
          case 'newuser':
            this.showAssignUser = false;
            break;
        }

      },
      selectProcedue(id) {
        if (this.$refs.procedureselector != null && this.$refs.procedureselector != undefined) {
          this.$refs.procedureselector.selectProcedure(id);
        }
      },
      getId() {
        return this._uid;
      },
      onTypeChange() {
        try {
          switch (this.selectedtype) {
            case 'user':
              //this.teamId = -1;
              //this.$refs.userSelectorRef.fetchReloadData();
              break;
            case 'team':
            case 'teammember':
              this.memberId = '';
              //this.$refs.teamSelectorRef.fetchReloadData(null);
              break;
          }
        }
        catch (err) {
          console.log(err);
          //alert(err);
        }
      },
      clearFields() {
        this.isGlobal = false;
        if (this.$refs.procedureselector != null && this.$refs.procedureselector != undefined) {
          this.$refs.procedureselector.clearFields();
          if (this.$refs.targetprocedureselector !== undefined) {
            this.$refs.targetprocedureselector.clearFields();
          }
        }

        if (this.$refs.projectselector != null && this.$refs.projectselector != undefined) {
          this.$refs.projectselector.clearFields();
        }
        if (this.$refs.locationselector != null && this.$refs.locationselector != undefined) {
          this.$refs.locationselector.clearFields();
        }
        if (this.$refs.shiftselector != null && this.$refs.shiftselector != undefined) {
          this.$refs.shiftselector.clearFields();
        }
        if (this.$refs.createScheduleControl != null && this.$refs.createScheduleControl != undefined) {
          this.$refs.createScheduleControl.clearFields();
        }

        this.$refs.teamSelectorRef.selectTeam("");
        this.$refs.userSelectorRef.selectUser("");

        this.order = '';

        this.status = 0;
        if ($("#select_status_" + this.getId()) != null && $("#select_status_" + this.getId()) != undefined) {
          $("#select_status_" + this.getId()).val(this.status);
          $("#select_status_" + this.getId()).trigger('change');
        }

      },
      setOverride(checked, val, value) {
        this.isGlobal = checked;
      },
      fetchReloadData() {
        try {
          this.$refs.projectselector.fetchReloadData();
          this.$refs.locationselector.fetchReloadData(null);
          this.$refs.shiftselector.fetchReloadData();

          if (this.$refs.userSelectorRef != null && this.$refs.userSelectorRef != undefined) {
            this.$refs.userSelectorRef.fetchReloadData();
            console.log('user data loaded');
          }
          if (this.$refs.teamSelectorRef != null && this.$refs.teamSelectorRef != undefined) {
            this.$refs.teamSelectorRef.fetchReloadData(null);
            console.log('team data loaded');
          }

        }
        catch (err) {
          //alert(err);
        }
      },
      onShiftData(count) {
        this.shiftCount = count;
        this.$forceUpdate();
      },
      onLocationData(count) {
        this.locationCount = count;
        this.$forceUpdate();
      },
      onProjectData(count) {
        this.projectCount = count;
        this.$forceUpdate();
      },
      onChange(id) {
        this.procedureId = id;
      },
      onTargetChange(id) {
        this.targetProcedureId = id;
      },
      onChangeTeam(teamid) {
        this.teamId = teamid;
      },
      onChangeMember(memberId) {
        this.memberId = memberId;
      },
      onChangeLocation(id) {
        this.locationId = id;
      },
      onChangeProject(id) {
        this.projectId = id;
      },
      onChangeShift(id) {
        this.shiftId = id;
      },
      doChange() {
        this.selected = $("#" + 'select_' + this.getId()).val();
      },
      setId(id) {
        this.id = id;
      },
      setShiftid(id) {
        this.shiftId = id;
      },
      async createSchedule() {

        if (this.shiftId !== null && this.shiftId < 0) {
          this.shiftId = null;
        }

        //this.$refs.projectselector.onFormSubmit();
        if ($('#schedulingCreateForm' + this.getId()).valid() == false)
          return false;

        var data = this.$refs.createScheduleControl.getSchedule();
        console.log(data);

        if (this.isGlobal == true) {
          this.projectId = -1;
          this.locationId = -1;
          this.shiftId = null;
          this.selectedtype = '';
          this.teamId = -1;
          this.memberId = '';
        } else {
          this.projectId = this.projectId === '' ? -1 : this.projectId;
          this.locationId = this.locationId === '' || this.locationId === null ? -1 : this.locationId;
          this.shiftId = this.shiftId === '' ? -1 : this.shiftId;
          //this.shiftId = this.shiftId === null ? -1 : this.shiftId;
        }
        if (data.Time === '') {
          data.Time = '00:00';
        }
        if (data.Endtime === '') {
          data.Endtime = '00:00';
        }

        /*
        if (data.Time !== '' && data.StartDate == '') {
          // Do nothing, its only time and formatted properly
        }
        else if (data.Time !== '' && data.StartDate !== '') {
            //var date = data.StartDate + ' ' + data.Time;
            var dateAndtime = convertNormalDate(data.StartDate);
            data.StartDate = convertToDate(dateAndtime);
            data.Time = data.Time;
        }
        else if (data.StartDate !== '') {
          //var date = data.StartDate + ' ' + '00:00';
          var dateAndtime = convertNormalDate(data.StartDate);
          data.StartDate = convertToDate(dateAndtime);
        }
        */

        if (data.StartDate !== '') {
          data.StartDate = convertNormalDate(data.StartDate);
        }

        /*
        if (data.Endtime !== '' && data.EndDate == '') {
          // Do nothing, its only time and formatted properly
        }
        else if (data.Endtime !== '' && data.EndDate !== '') {
            //var date = data.EndDate + ' ' + data.Endtime;
          var dateAndtime = convertNormalDate(data.EndDate);
            data.EndDate = convertToDate(dateAndtime);
            data.Endtime = data.Endtime;
        } else if (data.EndDate !== '') {
          //var date = data.EndDate + ' 00:00';
          var dateAndtime = convertNormalDate(data.EndDate);
          data.EndDate = convertToDate(dateAndtime);
        }
        */

        if (data.EndDate !== '') {
          data.EndDate = convertNormalDate(data.EndDate);
        }




        if (this.targetProcedureId > 0) {
          data.TargetProcedureId = this.targetProcedureId;
        }

        //alert("teamid:" + this.teamId )
        //alert("this.selectedtype:" + this.selectedtype)
        //alert("calling backend")
        if (this.selectedtype === '' || this.selectedtype === undefined
          || this.selectedtype === null) {
          this.memberId = null;
          //this.teamId = null;
        }
        if (this.order > -1)
          this.order = this.order.toString()
        var request = {
          procedureId: this.procedureId, model: data, projectId: this.projectId,
          locationId: this.locationId, shiftid: this.shiftId, isglobal: this.isGlobal,
          schdeduleFor: this.selectedtype, user: this.memberId, teamId: this.teamId, id: this.id,
          order: this.order, status: this.status
        };
        console.log(request);



        try {
          var response = await this.$http.post(
            '/api/Procedures/v1/AddProcedureSchedule',
            request
          ).then(async response => {
            this.clearFields();
            this.id = -1;
            if (this.openInPopup === "true") {
              this.$emit('event-add-procedureSch');
            } else {
              vm.$root.$emit('refreshview');
            }
          });

        } catch (err) {
          alert(err);
        }
      },

      async getProcedureSchedule(id) {
        try {
          this.clearFields();
          if (id > 0) {
            this.id = id;
            this.$http.get('/api/Procedures/v1/GetProcedureActivity?id=' + id).then(async response => {
              var schactivity = response.data;
              //alert(JSON.stringify(schactivity))

              /*
              if (schactivity.Time !== '' && schactivity.Time !== null) {
                if (schactivity.date === '') {
                  var date = '1901-01-01' + ' ' + schactivity.Time;
                  schactivity.Time = convertToTime(date);
                } else {
                  var date = schactivity.date + ' ' + schactivity.Time;
                  schactivity.date = getDateWithFormat(date);
                  schactivity.Time = convertToTime(date);
                }
              } else if ((schactivity.Time === '' || schactivity.Time === null) && schactivity.date !== '') {
                schactivity.Time = '00:00';
                var date = schactivity.date + ' ' + schactivity.Time;
                schactivity.date = getDateWithFormat(date);
              }
              */

              if (schactivity.date !== '') {
                schactivity.date = convertShortDateToLocal(schactivity.date);
              }


              if (schactivity.EndTime !== '' && schactivity.EndTime !== null) {
                if (schactivity.endDate === '') {
                  var date = '1901-01-01' + ' ' + schactivity.EndTime;
                  schactivity.EndTime = convertToTime(date);
                } else {
                  var date = schactivity.endDate + ' ' + schactivity.EndTime;
                  schactivity.endDate = getDateWithFormat(date);
                  schactivity.EndTime = convertToTime(date);
                }
              } else if ((schactivity.EndTime === '' || schactivity.EndTime === null) && schactivity.date !== '') {
                schactivity.EndTime = '00:00';
                var date = schactivity.endDate + ' ' + schactivity.EndTime;
                schactivity.endDate = getDateWithFormat(date);
              }



              this.$refs.createScheduleControl.setControls(schactivity.Type, schactivity.date,
                schactivity.Weekdays, schactivity.Time, schactivity.endDate, schactivity.EndTime,
                schactivity.WeekRepeat
              );

              this.locationId = schactivity.LocationId;
              this.procedureId = schactivity.ProcedureId;
              this.targetProcedureId = schactivity.TargetProcedureId;
              if (schactivity.ProjectId != null)
                this.projectId = schactivity.ProjectId;
              //if (schactivity.TeamId != null)
              //  this.teamId = schactivity.TeamId
              this.isGlobal = schactivity.IsGlobal;
              this.WeekRepeat = schactivity.WeekRepeat;

              //{, "date": "2022-06-17", "Time": "22:00",, "Order": 0, "EndTime": "22:00", "endDate": "2022-06-17", "Status": 0 }

              if (schactivity.Type == "onproceduredone") {
                this.showTargetProcedure = true;
              }
              this.changeType(schactivity.Type);
              this.order = schactivity.Order;

              this.status = schactivity.Status;
              if ($("#select_status_" + this.getId()) != null && $("#select_status_" + this.getId()) != undefined) {
                $("#select_status_" + this.getId()).val(this.status);
                $("#select_status_" + this.getId()).trigger('change');
              }

              this.selectedtype = schactivity.ScheduleFor;
              $("#select_assigned_type_" + this.getId()).val(this.selectedtype);
              $("#select_assigned_type_" + this.getId()).trigger('change');

              if (this.isGlobal == false) {
                if (this.$refs.procedureselector != null && this.$refs.procedureselector != undefined && schactivity.ProcedureId != null) {
                  this.$refs.procedureselector.selectProcedure(schactivity.ProcedureId);
                }
                if (this.$refs.targetprocedureselector != null && this.$refs.targetprocedureselector != undefined && schactivity.TargetProcedureId != null) {
                  this.$refs.targetprocedureselector.selectProcedure(schactivity.TargetProcedureId);
                }

                if (this.$refs.projectselector != null && this.$refs.projectselector != undefined && schactivity.ProjectId != null) {
                  this.$refs.projectselector.selectProject(schactivity.ProjectId);
                }
                if (this.$refs.locationselector != null && this.$refs.locationselector != undefined && schactivity.LocationId != null) {
                  this.$refs.locationselector.selectLocation(schactivity.LocationId);
                }
                if (this.$refs.shiftselector != null && this.$refs.shiftselector != undefined && schactivity.SiteShiftId != null) {
                  this.$refs.shiftselector.selectShift(schactivity.SiteShiftId);
                }
              }
              switch (this.selectedtype) {
                case 'user':
                  this.teamId = -1;
                  this.memberId = schactivity.User;
                  this.$refs.userSelectorRef.selectUser(schactivity.User);
                  break;
                case 'team':
                case 'teammember':
                  this.memberId = '';
                  if (schactivity.TeamId != null) {
                    this.teamId = schactivity.TeamId;
                    this.$refs.teamSelectorRef.selectTeam(schactivity.TeamId);
                  }
                  break;
              }

              if (schactivity.Type == "addedtoteam" && schactivity.TeamId != null) {
                this.teamId = schactivity.TeamId;
                this.$refs.teamSelectorRef.selectTeam(schactivity.TeamId);
              }

            });
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },

    },
    watch: {
      id: function (newVal, oldVal) {
        this.clearFields();
        if (newVal > 0) {
          //this.getProcedureSchedule(newVal);
        } else {

        }
      },
    },
    mounted() {
      $('.schedulerselect').select2();
      this.$refs.locationselector.displayAddButton = false;
      _componentValidation('#schedulingCreateForm');
      this.$refs.createScheduleControl.showTimeOption = true;
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/scheduling/add-schedule-selector.vue